import { OrderTabView } from "@mcleod/dispatch";
import { AutogenLayoutWireHistoryList } from "./autogen/AutogenLayoutWireHistoryList";
import {  Label, LookupModelSearchEvent, TableRowDisplayEvent } from "@mcleod/components";

const ORDER_FIELD = "order_id";

export class WireHistoryList extends AutogenLayoutWireHistoryList {

    /** This is an event handler for the onRowDisplay event of tableWireFundsProcessing. */
    tableWireFundsProcessingOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const orderId = tableRow.data.get(ORDER_FIELD);
        if (orderId) this.setupOrderLink(tableRow.findComponentsByField(ORDER_FIELD)[0] as Label, orderId);
    }

    setupOrderLink(comp: Label, orderId) {
        comp.applyLinkStyle();
        comp.addClickListener(() => {
            OrderTabView.navigateTo({ key: orderId, newTab: true });
        });
    }

    private textboxPayeeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.non_office_emp = "Y"
    }
}
